export const frBackofficeUsers = {
    // BACKOFFICE USERS

    'backofficeUsers.list.pageTitle': 'Utilisateurs siège',
    'backofficeUsers.list.title': 'Utilisateurs siège',
    'backofficeUsers.list.emptyLabel': 'Aucun utilisateur siège pour le moment.',
    'backofficeUsers.list.actions.addBackofficeUser': 'Ajouter un utilisateur siège',
    'backofficeUsers.list.actions.importExcel': 'Import Excel',
    'backofficeUsers.list.actions.exportExcel': 'Export Excel',
    'backofficeUsers.list.headers.info': 'Informations utilisateur',
    'backofficeUsers.list.headers.email': 'Email',
    'backofficeUsers.list.headers.comments': 'Commentaire',
    'backofficeUsers.list.othersLabel': 'autres centres',
    'backofficeUsers.list.dialog.title': "Suppression d'utilisateur siège",
    'backofficeUsers.list.dialog.content':
        'Êtes-vous sûr de vouloir supprimer cet utilisateur siège ?',
    'backofficeUsers.list.dialog.validateLabel': 'Supprimer',
    'backofficeUsers.list.dialog.cancelLabel': 'Annuler',

    // BACKOFFICE USERS >> CREATE

    'backofficeUsers.create.pageTitle': 'Création utilisateur siège',
    'backofficeUsers.create.actions.cancelCreation': 'Annuler la création',
    'backofficeUsers.create.actions.addTheBackofficeUser': 'Enregistrer',
    'backofficeUsers.create.input.firstName': "Saisissez ici le prénom de l'Utilisateur *",
    'backofficeUsers.create.input.floatingLabelFirstName': 'Prénom',
    'backofficeUsers.create.input.lastName': "Saisissez ici le nom de l'Utilisateur *",
    'backofficeUsers.create.input.floatingLabelLastName': 'Nom',
    'backofficeUsers.create.input.code': "Saisissez ici le nom de l'Utilisateur",
    'backofficeUsers.create.input.floatingLabelCode': 'Code',
    'backofficeUsers.create.tabs.info': 'Informations',
    'backofficeUsers.create.tabs.favShops': 'Centres favoris',
    'backofficeUsers.create.tabs.groupLeaderShops': 'CENTRES ANIMÉS',
    'backofficeUsers.create.tabs.perms': 'Permissions',

    'backofficeUsers.duplicatePermissions.action': 'Dupliquer les permissions de...',
    'backofficeUsers.duplicatePermissions.dialog.title': "Choix de l'utilisateur",
    'backofficeUsers.duplicatePermissions.placeholder': 'Chercher un utilisateur',

    'backofficeUsers.create.tabs.notifications': 'Notifications',
    'backofficeUsers.create.tabs.favoriteShops.treeTitle': 'CHOIX DE SECTORISATION',
    'backofficeUsers.create.tabs.permissions.adminSectionTitle': 'PERMISSIONS GLOBALES',
    'backofficeUsers.create.tabs.permissions.contentSectionTitle': 'PERMISSIONS DE CONTENU',
    'backofficeUsers.create.tabs.permissions.toggles.backofficeusersread':
        'Lire les utilisateurs siège',
    'backofficeUsers.create.tabs.permissions.toggles.backofficeuserswrite':
        'Éditer les utilisateurs siège',
    'backofficeUsers.create.tabs.permissions.toggles.frontusersread': 'Lire les collaborateurs',
    'backofficeUsers.create.tabs.permissions.toggles.frontuserswrite': 'Éditer les collaborateurs',
    'backofficeUsers.create.tabs.permissions.toggles.groupsread': 'Lire les groupes',
    'backofficeUsers.create.tabs.permissions.toggles.groupswrite': 'Éditer les groupes',
    'backofficeUsers.create.tabs.permissions.toggles.shopsread': 'Lire les centres',
    'backofficeUsers.create.tabs.permissions.toggles.shopswrite': 'Éditer les centres',
    'backofficeUsers.create.tabs.permissions.toggles.teamsread': 'Lire les équipes',
    'backofficeUsers.create.tabs.permissions.toggles.teamswrite': 'Éditer les équipes',
    'backofficeUsers.create.tabs.permissions.toggles.pincodesread': 'Lire les codes PIN',
    'backofficeUsers.create.tabs.permissions.toggles.pincodeswrite': 'Éditer les codes PIN',
    'backofficeUsers.create.tabs.permissions.sectionTabs.packagedOrders': 'Bons Plans',
    'backofficeUsers.create.tabs.permissions.sectionTabs.operations': 'Plans de vente',
    'backofficeUsers.create.tabs.permissions.sectionTabs.surveys': 'Sondage',
    'backofficeUsers.create.tabs.permissions.sectionTabs.events': 'Évènement',
    'backofficeUsers.create.tabs.permissions.sectionTabs.videos': 'Instant Digital',
    'backofficeUsers.permissions.packagedorders.contentcreate': 'Création de bon plan',
    'backofficeUsers.permissions.gooddeals.contentcreate': 'Création de bon plan',
    'backofficeUsers.permissions.packagedorders.contentsynchronization':
        'Synchronisation des bons plans',
    'backofficeUsers.permissions.videos.contentcreate': 'Création de vidéo',
    'backofficeUsers.permissions.events.contentcreate': "Création d'évènement",
    'backofficeUsers.permissions.surveys.contentcreate': 'Création de sondage',
    'backofficeUsers.permissions.news.contentcreate': "Création d'actualités",
    'backofficeUsers.permissions.ItemHeader': 'PROPRIÉTAIRE',
    'backofficeUsers.permissions.ContentReadDraft': 'Voir les brouillons',
    'backofficeUsers.permissions.ContentPublishAs': 'Publier en tant que',
    'backofficeUsers.permissions.ContentReadPublished': 'Voir les publiés',
    'backofficeUsers.permissions.ContentEditDraft': 'Modifier les brouillons',
    'backofficeUsers.permissions.ContentAudience': 'Audience de publication',
    'backofficeUsers.permissions.ContentEditPublished': 'Modifier les publiés',
    'backofficeUsers.permissions.ContentPublish': 'Publier',
    'backofficeUsers.permissions.ContentUnpublish': 'Annuler la publication',
    'backofficeUsers.permissions.ContentReadResults': 'Voir les résultats',
    'backofficeUsers.permissions.ContentNotifications': 'Envoyer des notifications',
    'backofficeUsers.permsArray.mine': 'Les miens',
    'backofficeUsers.permsArray.everyone': 'Tout le monde',
    'backofficeUsers.permsArray.sectorsDivider': 'SECTORISATION',
    'backofficeUsers.create.tabs.permissions.toggleAll': 'Tout autoriser',
    'backofficeUsers.create.tabs.informations.createInfo':
        "Pas d'équipe pour le moment. Pour l'ajouter, rendez-vous dans l’onglet « Équipes » où vous pourrez affecter l'utilisateur siège à une équipe.",
    'backofficeUsers.create.tabs.informations.input.email':
        "Saisissez ici l'email de l'Utilisateur *",
    'backofficeUsers.create.tabs.informations.input.floatingLabelEmail': 'Adresse email',
    'backofficeUsers.create.tabs.informations.input.comment': 'Saisissez ici votre commentaire',
    'backofficeUsers.create.tabs.informations.input.floatingLabelComment': 'Commentaire',

    // BACKOFFICE USERS >> DETAILS

    'backofficeUsers.details.pageTitle': 'Détails utilisateur siège',
    'backofficeUsers.details.generalInfoTitle': 'INFORMATIONS GÉNÉRALES',
    'backofficeUsers.details.teamInfoTitle': 'LISTE DES ÉQUIPES',
    'backofficeUsers.details.detailsInfo':
        "Pas d'équipe pour le moment. Pour l'ajouter, rendez-vous dans l’onglet « Équipes » où vous pourrez affecter l'utilisateur siège à une équipe.",
    'backofficeUsers.details.actions.save': 'Enregistrer',
    'backofficeUsers.details.actions.removeBackofficeUser': "Supprimer l'utilisateur",
    'backofficeUsers.details.actions.disabledRemoveInfo':
        'Cet utilisateur siège possède des centres et ne peut être supprimé.',
    'backofficeUsers.details.actions.previous': 'Utilisateurs siège',
    'backofficeUsers.details.dialog.title': "Suppression de l'utilisateur siège",
    'backofficeUsers.details.dialog.content':
        'Êtes-vous sûr de vouloir supprimer cet utilisateur siège ?',
    'backofficeUsers.details.dialog.validateLabel': 'Supprimer',
    'backofficeUsers.details.dialog.cancelLabel': 'Annuler',
    'backofficeUsers.details.input.firstName': "Saisissez ici le prénom de l'Utilisateur *",
    'backofficeUsers.details.input.floatingLabelFirstName': 'Prénom',
    'backofficeUsers.details.input.lastName': "Saisissez ici le nom de l'Utilisateur *",
    'backofficeUsers.details.input.floatingLabelLastName': 'Nom',
    'backofficeUsers.details.input.code': "Saisissez ici le code de l'Utilisateur",
    'backofficeUsers.details.input.floatingLabelCode': 'Code',
    'backofficeUsers.details.tabs.info': 'Informations',
    'backofficeUsers.details.tabs.favShops': 'Centres favoris',
    'backofficeUsers.details.tabs.notifications': 'Notifications',
    'backofficeUsers.details.tabs.favoriteShops.treeTitle': 'CHOIX DE SECTORISATION',
    'backofficeUsers.details.tabs.informations.sectionTitle': 'Équipes',
    'backofficeUsers.details.tabs.informations.createInfo':
        "Pas d'équipe pour le moment. Pour l'ajouter, rendez-vous dans l’onglet « Équipes » où vous pourrez affecter l'utilisateur siège à une équipe.",
    'backofficeUsers.details.tabs.informations.input.email':
        "Saisissez ici l'email de l'Utilisateur *",
    'backofficeUsers.details.tabs.informations.input.floatingLabelEmail': 'Adresse email',
    'backofficeUsers.details.tabs.informations.input.comment': 'Saisissez ici votre commentaire',
    'backofficeUsers.details.tabs.informations.input.floatingLabelComment': 'Commentaire',

    //TOAST
    'backofficeUsers.import.success': 'Bravo! Utilisateurs siège importés avec succès',
};
